(function () {
  const root = document.querySelector('[data-currency-drawer]');
  if (!root) return;

  const openBtn = root.querySelector('[data-currency-drawer-open]');
  const panel = root.querySelector('[data-currency-drawer-panel]');
  const closeEls = root.querySelectorAll('[data-currency-drawer-close]');

  const open = () => {
    if (panel) panel.hidden = false;
    closeEls.forEach((el) => {
      if (el.classList.contains('currency-drawer__overlay')) el.hidden = false;
    });
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('currency-drawer-open');
    requestAnimationFrame(() => {
      root.classList.add('is-open');
    });
  };

  const close = () => {
    root.classList.remove('is-open');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('currency-drawer-open');
    window.setTimeout(() => {
      if (root.classList.contains('is-open')) return;
      if (panel) panel.hidden = true;
      closeEls.forEach((el) => {
        if (el.classList.contains('currency-drawer__overlay')) el.hidden = true;
      });
    }, 350);
  };

  if (openBtn) openBtn.addEventListener('click', open);
  closeEls.forEach((el) => el.addEventListener('click', close));

  document.addEventListener('keyup', (event) => {
    if (event.key === 'Escape' && root.classList.contains('is-open')) close();
  });
})();
